// Fash brand logo URLs from Firebase Storage
const STORAGE_BASE = 'https://firebasestorage.googleapis.com/v0/b/fash-70b87.firebasestorage.app/o';

export const FASH_LOGOS = {
  /** Black script logo on transparent/gray — use for favicons or neutral backgrounds */
  black: `${STORAGE_BASE}/fash%20logos%2F1.PNG?alt=media`,
  /** Purple script logo — primary brand logo for light backgrounds */
  purple: `${STORAGE_BASE}/fash%20logos%2F2.PNG?alt=media`,
  /** Lavender script logo — softer variant for accented backgrounds */
  lavender: `${STORAGE_BASE}/fash%20logos%2F3.PNG?alt=media`,
  /** White script logo — for dark backgrounds (admin, nav bars) */
  white: `${STORAGE_BASE}/fash%20logos%2F4.PNG?alt=media`,
  /** Full branding guide image */
  branding: `${STORAGE_BASE}/fash%20logos%2FFash%20Branding.PNG?alt=media`,
} as const;

/** Default logo for light backgrounds */
export const FASH_LOGO = FASH_LOGOS.purple;
/** Logo for dark backgrounds */
export const FASH_LOGO_LIGHT = FASH_LOGOS.white;

/**
 * Founders. Only these accounts can grant or revoke platform admin access,
 * and the list is never editable from inside the app.
 */
export const SUPER_ADMIN_EMAILS: readonly string[] = [
  'creditboostcharlie@gmail.com',
  'domdavisllc@gmail.com',
];

/**
 * Platform admin emails — these users see the view switcher and reach admin
 * routes without needing a synced claim. Additional admins are granted at
 * runtime via the `admin` custom claim and users/{uid}.role === 'admin'.
 */
export const ADMIN_EMAILS: readonly string[] = SUPER_ADMIN_EMAILS;
